export const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    padding: "40px",
  },
  innerContainer: {
    width: "100%",
    maxWidth: "600px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  headerSection: {
    textAlign: "center",
    marginBottom: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  iconWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px",
  },
  checkIcon: {
    width: "40px",
    height: "40px",
    backgroundColor: "#ff3366",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 12px rgba(255, 51, 102, 0.25)",
    marginBottom: "5px",
  },
  statusText: {
    fontWeight: "700",
    fontSize: "14px",
    color: "#000",
  },
  title: {
    fontSize: "32px",
    color: "#111827",
    margin: "0 0 12px 0",
    fontWeight: "800",
  },
  subtitle: {
    color: "#4b5563",
    margin: "0 0 25px 0",
    fontSize: "16px",
    lineHeight: "1.5",
  },
  badge: {
    display: "inline-block",
    backgroundColor: "#e0f2fe",
    color: "#0284c7",
    padding: "8px 24px",
    borderRadius: "100px",
    fontWeight: "700",
    fontSize: "15px",
  },
  nextStepContainer: {
    width: "100%",
    maxWidth: "434px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "0 auto",
  },
  nextStepTitle: {
    color: "#1E293B",
    fontSize: "20px",
    fontWeight: 500,
    margin: "0 0 12px 0",
    textAlign: "center",
    width: "100%",
  },
  nextStepTextContainer: {
    width: "100%",
    maxWidth: "413px",
  },
  nextStepText: {
    color: "#525866",
    fontSize: "16px !important",
    fontWeight: 400,
    margin: 0,
    lineHeight: "1.5",
    textAlign: "left",
  },
  link: {
    fontWeight: 700,
    textDecoration: "underline",
    color: "inherit",
    cursor: "pointer",
  },
};
